<template>
  <div
    class="header-avatar"
    :style="wrapperStyle"
    :class="{ border: hasBorder }"
  >
    <img v-src="image" :style="imageStyle" @error="$emit('image-error')" />
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 46,
    },
    borderRadius: {
      type: Number,
      default: 5,
    },
    bg: {
      type: String,
      default: 'rgba(48, 63, 79, 1)',
    },
    fit: {
      type: String,
      default: 'contain',
    },
    hasBorder: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    wrapperStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        background: this.bg,
        borderRadius: `${this.borderRadius}px`,
      };
    },
    imageStyle() {
      return {
        objectFit: this.fit,
        borderRadius: `${this.borderRadius}px`,
      };
    },
  },
};
</script>

<style lang="less" scoped>
.header-avatar {
  position: relative;
  &.border {
    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: -1px;
      left: -1px;
      border-radius: 6px;
      border: rgba(255, 255, 255, 0.2) 1px solid;
      z-index: 1;
    }
  }
  img {
    position: relative;
    width: 100%;
    height: 100%;
  }
}
</style>
